import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import './Products.css';

const Products = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.2 });
  
  const products = [
    {
      title: 'Frozen Poultry',
      description: 'Premium chicken, turkey, and other poultry products sourced from trusted Nigerian farms.',
      items: ['Whole Chicken', 'Chicken Parts', 'Turkey', 'Duck'],
      image: '/images/poultry.jpg',
      color: '#C75B39',
    },
    {
      title: 'Frozen Fish & Seafood',
      description: 'Fresh-frozen fish and seafood from Nigeria\'s finest coastal waters.',
      items: ['Tilapia', 'Mackerel', 'Shrimp', 'Catfish'],
      image: '/images/meat.jpg',
      color: '#4A7C59',
    },
    {
      title: 'Frozen Meat',
      description: 'Quality beef, goat, and lamb cuts from certified suppliers.',
      items: ['Beef Cuts', 'Goat Meat', 'Lamb', 'Offals'],
      image: '/images/frozen-meat.jpg',
      color: '#8B4513',
    },
    {
      title: 'Frozen Vegetables',
      description: 'Farm-fresh vegetables frozen at peak quality for maximum nutrition.',
      items: ['Mixed Vegetables', 'Green Peas', 'Carrots', 'Sweet Corn'],
      image: '/images/vegetables.jpg',
      color: '#E8A838',
    },
  ];


  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15,
      },
    },
  };

  const cardVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, ease: 'easeOut' },
    },
  };

  return (
    <section className="products" id="products" ref={ref}>
      <div className="container">
        <motion.div 
          className="section-header"
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
        >
          <h2 className="section-title">Our Product Range</h2>
          <p className="section-subtitle">
            Wide selection of premium frozen foods to meet all your business needs
          </p>
        </motion.div>

        <motion.div 
          className="products-grid"
          variants={containerVariants}
          initial="hidden"
          animate={isInView ? 'visible' : 'hidden'}
        >
          {products.map((product, index) => (
            <motion.div 
              key={index} 
              className="product-card"
              variants={cardVariants}
              whileHover={{ y: -12 }}
            >
              <div className="product-image-wrapper">
                <img 
                  src={product.image} 
                  alt={product.title}
                  className="product-image"
                  loading="lazy"
                />
                <div className="product-overlay">
                  <div className="product-items-list">
                    {product.items.map((item, idx) => (
                      <span key={idx} className="product-item-tag">{item}</span>
                    ))}
                  </div>
                </div>
              </div>
              <div className="product-content">
                <h3 className="product-title">{product.title}</h3>
                <p className="product-description">{product.description}</p>
                <motion.button 
                  className="product-btn"
                  whileHover={{ scale: 1.03 }}
                  whileTap={{ scale: 0.97 }}
                  style={{ '--accent-color': product.color }}
                >
                  <span>View Details</span>
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M5 12h14M12 5l7 7-7 7"/>
                  </svg>
                </motion.button>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Products;
